<template lang="pug">
  .dashboard-container
    b-container
      .header
        .header-body
          b-row.align-items-end
            b-col
              h6.header-pretitle
                | Bienvenido
              h1.header-title
                | Vicente Guerra
            b-col(cols="auto", style="text-align:right;")
              b-dropdown#dropdown-right(right='', text='En línea - 01:30:15 hrs', variant='soft-success')
                b-dropdown-item(href='#') En línea
                b-dropdown-item(href='#') Backoffice
                b-dropdown-item(href='#') Desconectado
      b-card
        b-row.align-items-center
          b-col.py-2
            h5
              span.mr-2 Hoy estás asignado a
              b-badge.mr-2(variant="light") Marketing
              span.mr-2 en las plataformas
              b-badge.mr-2(variant="light") Twitter
              span.mr-2 y
              b-badge(variant="light") Whatsapp
            .text-help Último inicio de sesión el lunes 15 de abril del 2019 a las 15:30 pm.
          b-col.py-2(md="auto")
            b-button(variant="primary") Ir a inbox
      b-row
        b-col(md="8")
          b-card(title="Notas del administrador")
            ul.list-unstyled
              b-media.mt-4(tag='li')
                b-img(rounded, slot='aside', blank='', blank-color='#eee', width='64', alt='placeholder')
                p.mb-0
                  | Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin.
                  | Cras purus odio, vestibulum in vulputate at, tempus viverra turpis.
              b-media.mt-4(tag='li')
                b-img(rounded, slot='aside', blank='', blank-color='#eee', width='64', alt='placeholder')
                p.mb-0
                  | Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin.
                  | Cras purus odio, vestibulum in vulputate at, tempus viverra turpis.
          b-card(title="Follow up")
            b-list-group
              b-list-group-item.d-flex.align-items-start
                b-badge.mr-4(variant="soft-danger")
                  div 15
                  div ABR
                span Seguimiento a JC Viramontes
              b-list-group-item.d-flex.align-items-start
                b-badge.mr-4(variant="soft-warning")
                  div 20
                  div ABR
                span Seguimiento a Luis Zepeda
              b-list-group-item.d-flex.align-items-start
                b-badge.mr-4(variant="soft-secondary")
                  div 1
                  div JUN
                span Envío de actualización
              b-list-group-item.d-flex.align-items-start
                b-badge.mr-4(variant="soft-secondary")
                  div 15
                  div JUN
                span Hashtag #interjetplus (campaña)
        b-col(md="4")
          b-card(title="Tu tracking semanal")
            .text-help Aún no hay datos disponibles
            b-img(center, style="width:100%;margin-top:1rem;", src="./../../assets/building-graph.png")
          b-card(title="Tendencias")
            b-list-group
              b-list-group-item.d-flex.justify-content-between.align-items-center
                span Interjet en quiebra
                b-badge(variant="soft-danger", pill) 130
              b-list-group-item.d-flex.justify-content-between.align-items-center
                span #interjetplus
                b-badge(variant="soft-secondary", pill) 23
              b-list-group-item.d-flex.justify-content-between.align-items-center
                span #vacaciones
                b-badge(variant="soft-secondary", pill) 15
</template>

<script>
  export default {
    data () {
      return {
        form: {
          food: null
        },
        items: [
          { age: 40, first_name: 'Dickerson', last_name: 'Macdonald' },
          { age: 21, first_name: 'Larsen', last_name: 'Shaw' },
          { age: 89, first_name: 'Geneva', last_name: 'Wilson' },
          { age: 38, first_name: 'Jami', last_name: 'Carney' }
        ],
        fields: [
          {
            key: 'index',
            label: '#'
          },
          'age',
          'first_name',
          'last_name'
        ],
        elapsed_time: 0
      }
    },
    methods: {
      errorImg (e) {

      }
    },

    mounted () {
      let self = this

      setInterval(function () {
        self.elapsed_time ++
      }, 1000);
    }
  }
</script>

<style lang="scss">
  .dashboard-container {
    display: flex;
    flex-flow: column;
    width: 100%;
    height: 100%;
    padding: 0;
  }
</style>
